export const FETCH_GATE_REQUEST = 'gates/FETCH_GATE_REQUEST'
export const FETCH_GATE_SUCCESS = 'gates/FETCH_GATE_SUCCESS'
export const FETCH_GATE_FAILURE = 'gates/FETCH_GATE_FAILURE'

export const UPDATE_GATE_REQUEST = 'gates/UPDATE_GATE_REQUEST'
export const UPDATE_GATE_SUCCESS = 'gates/UPDATE_GATE_SUCCESS'
export const UPDATE_GATE_FAILURE = 'gates/UPDATE_GATE_FAILURE'
